// Serialize the store back into the v3 content payload the backend expects,
// byte-for-byte compatible with v1's getPostData(). The per-element `id` we add
// for store keying is stripped so the wire format matches v1 exactly (lossless).

export function toContent(state) {
  const content = {
    version: 3,
    view: { scale: state.view.scale, posX: state.view.posX, posY: state.view.posY },
    settings: state.settings,
    elements: state.elements.map(({ id, ...el }) => el),
    layers: state.layers,
  };
  if (state.image) content.image = state.image;
  return content;
}

export function toPlanPayload(state) {
  return {
    plan: {
      content: toContent(state),
      name: state.settings?.name ?? state.name,
      access: state.settings?.access,
    },
  };
}

// A deep-cloned snapshot of the editable state for the undo stack.
export function snapshot(state) {
  return JSON.parse(JSON.stringify({
    elements: state.elements,
    layers: state.layers,
    image: state.image,
    settings: state.settings,
  }));
}
